import { type Clinic } from "./clinics.type";

export const enum NotificationTypes {
  "APPOINTMENT" = 1,
  "MESSAGE" = 2,
  "REPORT" = 3,
  "INTAKE_FORM" = 4,
  "TASK" = 5,
  "NOAH_HISTORY_SYNCED" = 6,
  "TOUCHPOINT" = 7,
  "AMBIENT_SCRIBE" = 8
}

export interface BaseNotification {
  id: number;
  title: string;
  description: string;
  is_read: boolean;
  provider: number;
  clinic: Clinic;
  is_active: boolean;
  created_at: string;
}

export interface AppointmentNotification extends BaseNotification {
  type: 1;
}

export interface MessageNotification extends BaseNotification {
  type: 2;
  extra: {
    patient_id: number;
  };
}

export interface ReportNotification extends BaseNotification {
  type: 3;
  extra: {
    csv_title: string;
    provider_id: number;
    csv_download_url: string;
    expires_utc_epoch: number;
  };
}

export interface IntakeFormNotification extends BaseNotification {
  type: 4;
  extra: {
    form_ids: number[];
    patient_id: number;
    submitted_by_id: number;
    intake_form_request_id: number;
  };
}

export interface TaskNotification extends BaseNotification {
  type: 5;
  extra: {
    patient_id: number | null;
    task: number;
    id: number;
  };
}

export interface NoahSyncedNotification extends BaseNotification {
  type: 6;
  extra: {
    patient_id: number | null;
    provider_id: number;
  };
}

export interface TouchpointNotification extends BaseNotification {
  type: 7;
  extra: {
    patient_id: number | null;
    fax_id: number | null;
    touchpoint_id: number | null;
    error: string | null;
  };
}

export interface AmbientScribeNotification extends BaseNotification {
  type: 8;
  extra: {
    patient_id: number | null;
    scribe_id: number | null;
    chart_note_id: number | null;
  };
}

export type Notification =
  | AppointmentNotification
  | MessageNotification
  | ReportNotification
  | IntakeFormNotification
  | TaskNotification
  | NoahSyncedNotification
  | TouchpointNotification
  | AmbientScribeNotification;

export type NotificationSocketResponse = {
  type: "new.user.notification";
  message: Notification;
};

export type NotificationFilters = {
  provider: number;
  clinic?: number;
  type?: NotificationTypes | null;
  is_read?: boolean;
  is_active?: boolean;
  limit?: number;
  offset?: number;
};
